import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { education } from "../data/portfolioData";

export default function Journey() {
  return (
    <section id="education" className="cyber-section">
      <div className="container">
        {/* Section Header */}
        <div className="mb-5">
          <div className="section-label">ACADEMIC FOUNDATION</div>
          <h2 className="section-title">Education</h2>
          <p className="section-subtitle">
            Formal computer science and application development background providing deep
            foundational knowledge of systems, networking, and software engineering.
          </p>
        </div>

        <div className="row g-4">
          {education.map((edu, idx) => (
            <div key={idx} className="col-md-6">
              <div
                className="cyber-card p-4 h-100"
                style={{
                  background: "var(--bg-surface)",
                  borderColor: "var(--border-subtle)",
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "10px",
                      background: "rgba(56, 189, 248, 0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "var(--accent)",
                      fontSize: "1.1rem",
                    }}
                  >
                    <FontAwesomeIcon icon={faGraduationCap} />
                  </div>

                  <span
                    className="badge font-mono"
                    style={{
                      background: edu.status.includes("Completed") ? "rgba(34, 197, 94, 0.1)" : "rgba(56, 189, 248, 0.1)",
                      color: edu.status.includes("Completed") ? "#86efac" : "var(--accent)",
                      border: `1px solid ${edu.status.includes("Completed") ? "rgba(34, 197, 94, 0.3)" : "rgba(56, 189, 248, 0.3)"}`,
                      fontSize: "0.75rem",
                    }}
                  >
                    {edu.status}
                  </span>
                </div>

                <h3 style={{ fontSize: "1.2rem", fontWeight: 700, color: "var(--text-primary)", marginBottom: "6px" }}>
                  {edu.degree}
                </h3>

                <div className="d-flex align-items-center gap-2 mb-3">
                  <span className="font-mono text-muted" style={{ fontSize: "0.82rem" }}>
                    {edu.institution}
                  </span>
                  <span className="text-muted">•</span>
                  <span className="font-mono" style={{ fontSize: "0.82rem", color: "var(--accent)" }}>
                    {edu.period}
                  </span>
                </div>

                <p style={{ fontSize: "0.88rem", color: "var(--text-secondary)", lineHeight: 1.6, marginBottom: 0 }}>
                  {edu.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
